import { CommonModule } from "@angular/common";
import { Component, OnInit, AfterViewInit, ViewChild, VERSION, Directive, Input, ElementRef, HostListener, ComponentFactoryResolver, Injector, ApplicationRef, EmbeddedViewRef, ComponentRef, Renderer2, ChangeDetectorRef } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UtilityService } from 'src/app/services/utility.service';
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { FormControl, FormGroup, NgForm } from "@angular/forms";
import { DrupalRESTService } from "src/app/services/drupal-rest.service";
import { ActivatedRoute, Event, Params, Router } from "@angular/router";
import { saveAs } from 'file-saver';
import moment from "moment";
import { ViewTableComponent } from "../../base/view-table/view-table.component";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { FormBuilder } from '@angular/forms';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from "@ngx-translate/core";
import { PrintService } from 'src/app/services/print.service';
import { WeekYearChangeEvent } from '../../shared/week-year-selector/week-year-selector.component';
import { CurrencyService } from '../../../services/currency.service';
import { LoggerService } from '../../../services/logger.service';
// Custom HTML Tooltip Component
@Component({
  selector: 'app-html-tooltip',
  template: `
    <div class="html-tooltip-content" [innerHTML]="content"></div>
  `,
  styles: [`
    .html-tooltip-content {
      background-color: white;
      color: black;
      border: 1px solid #ccc;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      padding: 10px;
      max-width: 800px;
      max-height: 400px;
      overflow: auto;
      position: fixed;
      z-index: 1000;
    }
  `]
})
export class HtmlTooltipComponent {
  content: SafeHtml;
}

// Custom HTML Tooltip Directive
@Directive({
  selector: '[htmlTooltip]'
})
export class HtmlTooltipDirective {
  @Input('htmlTooltip') tooltipContent: string;
  private tooltipElement: HTMLElement | null = null;

  constructor(
    private el: ElementRef
  ) { }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this.tooltipContent) {
      this.show();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.hide();
  }

  private show(): void {
    LoggerService.log('Showing tooltip with content:', this.tooltipContent);

    // Remove any existing tooltip
    this.hide();

    // Create tooltip container
    this.tooltipElement = document.createElement('div');

    // Apply inline styles directly to ensure they take precedence
    const style = this.tooltipElement.style;
    style.position = 'absolute';
    style.backgroundColor = '#ffffff';
    style.color = '#000000';
    style.border = '2px solid #0066cc';
    style.borderRadius = '6px';
    style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.25)';
    style.padding = '0';
    style.maxWidth = '850px';
    style.maxHeight = '450px';
    style.overflow = 'auto';
    style.zIndex = '99999';
    style.fontSize = '14px';
    style.opacity = '1';

    // Initially position off-screen to measure size
    style.top = '-9999px';
    style.left = '-9999px';

    // Set content
    this.tooltipElement.innerHTML = this.tooltipContent;

    // Add to DOM
    document.body.appendChild(this.tooltipElement);

    // Use setTimeout to ensure the element is rendered before measuring
    setTimeout(() => {
      if (!this.tooltipElement) return;

      // Position the tooltip
      const rect = this.el.nativeElement.getBoundingClientRect();
      const tooltipRect = this.tooltipElement.getBoundingClientRect();

      let top = rect.bottom + window.scrollY + 5;
      let left = rect.left + window.scrollX;

      // Adjust position if needed
      if (left + tooltipRect.width > window.innerWidth) {
        left = window.innerWidth - tooltipRect.width - 10;
      }

      if (top + tooltipRect.height > window.innerHeight + window.scrollY) {
        top = rect.top + window.scrollY - tooltipRect.height - 5;
      }

      // Update position
      style.top = `${top}px`;
      style.left = `${left}px`;

      LoggerService.log('Tooltip positioned at:', top, left, 'with dimensions:', tooltipRect.width, tooltipRect.height);
    }, 0);
  }

  private hide(): void {
    if (this.tooltipElement && this.tooltipElement.parentNode) {
      this.tooltipElement.parentNode.removeChild(this.tooltipElement);
      this.tooltipElement = null;
    }
  }
}

@Component({
  selector: 'app-studio-business-summary',
  templateUrl: './studio-business-summary.component.html',
  styleUrls: ['./studio-business-summary.component.css']
})
export class StudioBusinessSummaryComponent extends ViewTableComponent implements OnInit {

  override displayedColumns: string[] = [
    'column_1',
    'column_2',
  ];

  consumable: any;

  currentReport: string = 'studioBusiness';
  week: string;
  year: string;

  Math: Math = Math;

  // YTD loading state
  ytdDataLoaded: boolean = false;
  ytdDataFailed: boolean = false;
  originalConsumableData: any = null;
  // Feature flag to enable/disable YTD processing without leaving unreachable code
  private enableYtdProcessing: boolean = false;

  // Helper method to round numbers to 2 decimal places to fix floating point precision issues
  roundNumber(value: number, decimals: number = 2): number {
    return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  }

  // Template helper method for currency calculations
  calculateTotal(...values: number[]): number {
    const sum = values.reduce((acc, val) => acc + (val || 0), 0);
    return this.roundNumber(sum, 2);
  }

  constructor(
    public override _refreshService: RefreshService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService,
    private _printService: PrintService,
    private currencyService: CurrencyService,
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  // Get the current studio name from AuthService
  get currentStudio(): string {
    return this._authService.selectedStudio?.name ||
           this._authService.selectedStudio?.key ||
           'Unknown Studio';
  }

  // Get tooltip message for disabled send/update buttons
  get disabledButtonTooltip(): string {
    if (!this.isDisabled) {
      return '';
    }

    if (this.week && this.year) {
      let selectedDate = moment().isoWeekYear(+this.year).isoWeek(+this.week);
      let weekEnd = selectedDate.clone().endOf('isoWeek').startOf('day').add(1, 'day'); // Monday after the week ends
      let now = moment();

      // Calculate days until Monday (when report is actually available)
      let daysUntilReady = Math.ceil(weekEnd.diff(now, 'days', true));

      if (daysUntilReady < 0) {
        return ''; // Should not happen if isDisabled logic is correct
      } else if (daysUntilReady === 1) {
        return 'Ready tomorrow';
      } else {
        return `Ready in ${daysUntilReady} days`;
      }
    }

    return 'Ready after the week ends';
  }

  // Check if report data should be shown (after YTD processing is complete)
  get shouldShowReportData(): boolean {
    return this.ytdDataLoaded || this.ytdDataFailed;
  }

  override ngOnInit() {
    // Don't call super.ngOnInit() to prevent automatic getData() call
    // This component handles data loading in ngAfterContentInit() based on route params
  }

  override ngOnDestroy() {
    // Cleanup handled by parent class
  }

  onYearChange(event: any) {
    this.year = event.value;
    LoggerService.log('year', this.year)
    this.WeeksForYearData = this._fieldsService.WeeksForYearData(Number.parseInt(this.year));
  }

  onWeekYearChange(event: WeekYearChangeEvent): void {
    this.week = event.week;
    this.year = event.year;
    this.getData([
      { parameter: 'week', value: this.week },
      { parameter: 'year', value: this.year },
    ]);
  }

  override ngAfterContentInit(): void {
    this._activatedRoute.queryParams.subscribe(data => {
      // LoggerService.log('subscribed data', data)
      this.ShowProgressBar = false;

      if (data['year']) {
        this.year = data['year']
      } else {
        this.year = this._fieldsService.getCorrectYearForWeek(new Date()).toString();
      }
      if (data['week']) {
        this.week = data['week']
      } else {
        this.week = this._fieldsService.getCurrentWeek().toString();
      }

      // Update weeks dropdown data to match the year
      this.WeeksForYearData = this._fieldsService.WeeksForYearData(Number.parseInt(this.year));

      this.getData([
        { parameter: 'week', value: this.week },
        { parameter: 'year', value: this.year },
      ]);
    })
  }

  override getData(params) {
    // Create a moment object for the selected week/year
    let selectedDate = moment().isoWeekYear(+this.year).isoWeek(+this.week);
    // Get end of selected week (Sunday)
    let weekEnd = selectedDate.clone().endOf('isoWeek');
    // Create current date for comparison
    let currentDate = moment();

    // Compare the dates - disable if current date hasn't passed Sunday of the selected week
    this.isDisabled = !weekEnd.isBefore(currentDate);

    this.clearFormTableData();

    // Reset YTD loading state
    this.ytdDataLoaded = false;
    this.ytdDataFailed = false;
    this.originalConsumableData = null;

    this.queryParams = params;

    // Add sorting paramaters, if available.
    if (this.sortParams !== undefined) {
      this.queryParams.push(this.sortParams)
    }

    this.ShowProgressBar = true;

    // Load the new student list with the filtering parameters.
    this._utilityService.getStudioBusinessReport(
      this.queryParams
    )
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;
        // LoggerService.log(data['#studio_content_table']['studio_content_table']['#rows']);
        let rows = data['#studio_content_table']['studio_content_table']['#rows'];
        let consumable = data['#studio_content_table']['studio_content_table']['#consumable'];

        // Store original consumable data before YTD modifications
        this.originalConsumableData = JSON.parse(JSON.stringify(consumable));

        // Modify data to work in Angular.
        rows.forEach((element, index) => {
          // rows[index]['name'] = element.name.replace(/<[^>]*>?/gm, '');
        });

        this.data = data;

        // Don't set dataSource or consumable yet - wait for YTD data
        // this.dataSource = new MatTableDataSource(rows);
        // this.consumable = consumable;

        this.pageSize = rows.length;

        // Pagination configuration.
        this.updatePaginationConfig(rows);

        // Fetch YTD data from AMI API after loading the basic report
        this.fetchYTDData();
      },
        error => {
          this.ShowProgressBar = false;
          this.handleError(error);
        }
      )
  }

  /**
   * Fetches YTD data from AMI API and updates the local data
   */
  fetchYTDData() {
    // Only attempt to fetch YTD data if we already have a loaded report
    if (!this.data || !this.originalConsumableData) {
      return;
    }

    LoggerService.log('Fetching YTD data for week:', this.week, 'year:', this.year);

    // If disabled, immediately fall back to original data
    if (!this.enableYtdProcessing) {
      this.fallbackToOriginalData();
      this.showReportData();
      return;
    }

    // For YTD data, we always request the current week's YTD (which includes all weeks up to current)
    const ytdParams = [
      { parameter: 'week', value: this.week },
      { parameter: 'year', value: this.year }
    ];

    LoggerService.log('Fetching YTD data for current week:', ytdParams);

    this._utilityService.getStudioBusinessYTD(ytdParams)
      .subscribe(
        (ytdResponse: any) => {
          if (ytdResponse && ytdResponse.success && ytdResponse.data) {
            LoggerService.log('YTD data fetched successfully', ytdResponse.data);

            // Set consumable to original data first
            this.consumable = JSON.parse(JSON.stringify(this.originalConsumableData));

            // Update the consumable object with YTD data from API
            this.updateConsumableWithYTDData(ytdResponse.data);

            // Mark YTD as successfully loaded
            this.ytdDataLoaded = true;
            this.ytdDataFailed = false;
          } else {
            LoggerService.warn('YTD data not available or invalid format', ytdResponse);

            // Fall back to original data without YTD
            this.fallbackToOriginalData();
          }

          // Show the data now that we've processed YTD (success or failure)
          this.showReportData();
        },
        (error) => {
          LoggerService.error('Failed to fetch YTD data', error);

          // Fall back to original data without YTD
          this.fallbackToOriginalData();

          // Show the data with fallback
          this.showReportData();
        }
      );
  }

  /**
   * Falls back to showing original data without YTD modifications
   */
  private fallbackToOriginalData() {
    LoggerService.log('Falling back to original data without YTD modifications');

    // Set consumable to original data
    this.consumable = JSON.parse(JSON.stringify(this.originalConsumableData));

    // Mark YTD as failed
    this.ytdDataLoaded = false;
    this.ytdDataFailed = true;

    // Add indicator that we're showing fallback data
    this.consumable.ytd_data_source = 'Fallback - Original Data Only';
    this.consumable.ytd_last_updated = this.reportDateService.currentStudioDateKey();
  }

  /**
   * Shows the report data (called after YTD processing is complete)
   */
  private showReportData() {
    if (!this.data || !this.consumable) {
      return;
    }

    // Get rows from the data
    let rows = this.data['#studio_content_table']['studio_content_table']['#rows'];

    // Now we can show the data
    this.dataSource = new MatTableDataSource(rows);

    LoggerService.log('Report data now visible to user');
  }

  /**
   * Updates the consumable object with YTD data from AMI API
   * @param ytdData YTD data from API for the current week
   */
  updateConsumableWithYTDData(ytdData: any) {
    if (!this.consumable || !ytdData) {
      return;
    }

    // Add source indicator to consumable object
    this.consumable.ytd_data_source = 'YTD from External System';
    this.consumable.ytd_last_updated = this.reportDateService.currentStudioDateKey();

    LoggerService.log('Setting YTD values from external system for week', this.week, 'year', this.year);
    LoggerService.log('Raw YTD data from API:', ytdData);

    // Map AMI API field names to our component field names where they differ
    const fieldMappings = {
      'cash': 'cash_ytd',
      'miscellaneous': 'miscellaneous_ytd',
      'refund_cash': 'refund_cash_ytd',
      'refund_miscellaneous': 'refund_miscellaneous_ytd',
      'contact': 'contact_ytd',
      'booked': 'booked_ytd',
      'showed': 'showed_ytd',
      'lessons_interviewed': 'DE_lessons_taught_ytd',
      'lessons_renewed': 'PVT_renewal_lessons_taught_ytd',
      'number_in_class': 'number_in_class_ytd',
      'pre_original_tried': 'pre_original_tried_ytd',
      'pre_original_sold': 'pre_original_sold_ytd',
      'pre_original_units': 'pre_original_units_ytd',
      'pre_original_sales': 'pre_original_sales_ytd',
      'original_tried': 'original_tried_ytd',
      'original_sold': 'original_sold_ytd',
      'original_units': 'original_units_ytd',
      'original_sales': 'original_sales_ytd',
      'extension_tried': 'extension_tried_ytd',
      'extension_sold': 'extension_sold_ytd',
      'extension_units': 'extension_units_ytd',
      'extension_sales': 'extension_sales_ytd',
      'renewal_tried': 'renewal_tried_ytd',
      'renewal_sold': 'renewal_sold_ytd',
      'renewal_units': 'renewal_units_ytd',
      'renewal_sales': 'renewal_sales_ytd',
      'non_unit_private_lessons': 'non_unit_private_lessons_ytd',
      'non_unit_private_sales': 'non_unit_private_sales_ytd',
      'non_unit_class_lessons': 'non_unit_class_lessons_ytd',
      'non_unit_class_sales': 'non_unit_class_sales_ytd',
      'miscellaneous_sales': 'miscellaneous_sales_ytd',
      // Add fields that might be missing
      'sundry': 'sundry_ytd',
      'refund_sundry': 'refund_sundry_ytd',
      'pre_original_units_dropped': 'pre_original_units_dropped_ytd',
      'original_units_dropped': 'original_units_dropped_ytd',
      'extension_units_dropped': 'extension_units_dropped_ytd',
      'renewal_units_dropped': 'renewal_units_dropped_ytd',
      'non_unit_units_dropped': 'non_unit_units_dropped_ytd',
      'miscellaneous_units_dropped': 'miscellaneous_units_dropped_ytd',
      'pre_original_sales_dropped': 'pre_original_sales_dropped_ytd',
      'original_sales_dropped': 'original_sales_dropped_ytd',
      'extension_sales_dropped': 'extension_sales_dropped_ytd',
      'renewal_sales_dropped': 'renewal_sales_dropped_ytd',
      'non_unit_sales_dropped': 'non_unit_sales_dropped_ytd',
      'miscellaneous_sales_dropped': 'miscellaneous_sales_dropped_ytd',
      // Fix PVT interview lessons mapping
      'lessons_taught': 'PVT_interview_lessons_taught_ytd',
      // DE data
      'DE_tried': 'DE_tried_ytd',
      'DE_sold': 'DE_sold_ytd',
      'DE_units': 'DE_units_ytd',
      'DE_sales': 'DE_sales_ytd'
    };

    // Store YTD data from API
    this.consumable.ytd_data_from_api = {};

    // Track validation issues
    const validationIssues = [];

    // Set YTD data directly from API with validation
    Object.keys(fieldMappings).forEach(apiField => {
      if (ytdData[apiField] !== undefined) {
        const localField = fieldMappings[apiField];
        const ytdValue = ytdData[apiField];

        // Get corresponding current week field for validation
        const currentField = localField.replace('_ytd', '');
        const currentValue = parseFloat(this.consumable[currentField]) || 0;

        // Validate that YTD >= Current (except for negative values like refunds)
        if (!apiField.includes('refund') && ytdValue < currentValue) {
          validationIssues.push({
            field: apiField,
            ytdValue: ytdValue,
            currentValue: currentValue,
            issue: `YTD (${ytdValue}) < Current (${currentValue})`
          });
          LoggerService.warn(`❌ INVALID YTD DATA: ${apiField} YTD (${ytdValue}) < Current (${currentValue})`);
        }

        // Store original API value for reference
        this.consumable.ytd_data_from_api[localField] = ytdValue;

        // Set YTD value directly from API
        this.consumable[localField] = ytdValue;

        // Create styled version for display
        this.consumable[`${localField}_display`] = {
          value: ytdValue,
          fromOnlineReporting: true,
          isFromExternalSystem: true,
          hasValidationIssue: !apiField.includes('refund') && ytdValue < currentValue
        };

        LoggerService.log(`✅ ${apiField} -> ${localField}: ${ytdValue} (Current: ${currentValue})`);
      }
    });

    // Log validation summary
    if (validationIssues.length > 0) {
      LoggerService.error('🔥 YTD VALIDATION ISSUES DETECTED:', validationIssues);
      this.consumable.ytd_validation_issues = validationIssues;
    } else {
      LoggerService.log('✅ All YTD values passed validation');
    }

    // Ensure sundry_ytd has a default value of 0 if not provided
    if (this.consumable.sundry_ytd === undefined) {
      this.consumable.sundry_ytd = 0;
      this.consumable.ytd_data_from_api.sundry_ytd = 0;
      this.consumable.sundry_ytd_display = {
        value: 0,
        fromOnlineReporting: true,
        isFromExternalSystem: true
      };
    }

    // Ensure all YTD fields that might not be in API response have display objects
    const allYtdFields = [
      'cash_ytd', 'miscellaneous_ytd', 'sundry_ytd', 'refund_cash_ytd', 'refund_miscellaneous_ytd', 'refund_sundry_ytd',
      'contact_ytd', 'booked_ytd', 'showed_ytd',
      'DE_lessons_taught_ytd', 'PVT_interview_lessons_taught_ytd', 'PVT_renewal_lessons_taught_ytd',
      'number_in_class_ytd',
      'DE_tried_ytd', 'DE_sold_ytd', 'DE_units_ytd', 'DE_sales_ytd',
      'pre_original_tried_ytd', 'pre_original_sold_ytd', 'pre_original_units_ytd', 'pre_original_sales_ytd',
      'original_tried_ytd', 'original_sold_ytd', 'original_units_ytd', 'original_sales_ytd',
      'extension_tried_ytd', 'extension_sold_ytd', 'extension_units_ytd', 'extension_sales_ytd',
      'renewal_tried_ytd', 'renewal_sold_ytd', 'renewal_units_ytd', 'renewal_sales_ytd',
      'non_unit_private_lessons_ytd', 'non_unit_private_sales_ytd',
      'non_unit_class_lessons_ytd', 'non_unit_class_sales_ytd',
      'miscellaneous_sales_ytd'
    ];

    // Create display objects for any missing YTD fields
    allYtdFields.forEach(field => {
      if (this.consumable[field] !== undefined && !this.consumable[`${field}_display`]) {
        this.consumable[`${field}_display`] = {
          value: this.consumable[field],
          fromOnlineReporting: true,
          isFromExternalSystem: true
        };
      }
    });

    // Calculate totals for Unit Sales Tracking YTD
    this.calculateUnitSalesTrackingTotals();

    // Force change detection to update the UI
    this._changeDetectorRef.detectChanges();
  }

  /**
   * Calculates the total values for Unit Sales Tracking section
   */
  calculateUnitSalesTrackingTotals() {
    // Current week totals
    const totalTried =
      (parseFloat(this.consumable?.DE_tried) || 0) +
      (parseFloat(this.consumable?.pre_original_tried) || 0) +
      (parseFloat(this.consumable?.original_tried) || 0) +
      (parseFloat(this.consumable?.extension_tried) || 0) +
      (parseFloat(this.consumable?.renewal_tried) || 0);

    const totalSold =
      (parseFloat(this.consumable?.DE_sold) || 0) +
      (parseFloat(this.consumable?.pre_original_sold) || 0) +
      (parseFloat(this.consumable?.original_sold) || 0) +
      (parseFloat(this.consumable?.extension_sold) || 0) +
      (parseFloat(this.consumable?.renewal_sold) || 0);

    const totalUnits =
      (parseFloat(this.consumable?.DE_units) || 0) +
      (parseFloat(this.consumable?.pre_original_units) || 0) +
      (parseFloat(this.consumable?.original_units) || 0) +
      (parseFloat(this.consumable?.extension_units) || 0) +
      (parseFloat(this.consumable?.renewal_units) || 0);

    const totalSales =
      (parseFloat(this.consumable?.pre_original_sales) || 0) +
      (parseFloat(this.consumable?.original_sales) || 0) +
      (parseFloat(this.consumable?.extension_sales) || 0) +
      (parseFloat(this.consumable?.renewal_sales) || 0);

    // YTD totals
    const totalTriedYtd =
      (parseFloat(this.consumable?.DE_tried_ytd) || 0) +
      (parseFloat(this.consumable?.pre_original_tried_ytd) || 0) +
      (parseFloat(this.consumable?.original_tried_ytd) || 0) +
      (parseFloat(this.consumable?.extension_tried_ytd) || 0) +
      (parseFloat(this.consumable?.renewal_tried_ytd) || 0);

    const totalSoldYtd =
      (parseFloat(this.consumable?.DE_sold_ytd) || 0) +
      (parseFloat(this.consumable?.pre_original_sold_ytd) || 0) +
      (parseFloat(this.consumable?.original_sold_ytd) || 0) +
      (parseFloat(this.consumable?.extension_sold_ytd) || 0) +
      (parseFloat(this.consumable?.renewal_sold_ytd) || 0);

    const totalUnitsYtd =
      (parseFloat(this.consumable?.DE_units_ytd) || 0) +
      (parseFloat(this.consumable?.pre_original_units_ytd) || 0) +
      (parseFloat(this.consumable?.original_units_ytd) || 0) +
      (parseFloat(this.consumable?.extension_units_ytd) || 0) +
      (parseFloat(this.consumable?.renewal_units_ytd) || 0);

    const totalSalesYtd =
      (parseFloat(this.consumable?.pre_original_sales_ytd) || 0) +
      (parseFloat(this.consumable?.original_sales_ytd) || 0) +
      (parseFloat(this.consumable?.extension_sales_ytd) || 0) +
      (parseFloat(this.consumable?.renewal_sales_ytd) || 0);

    // Store the totals in consumable object with proper rounding
    this.consumable.total_tried = this.roundNumber(totalTried);
    this.consumable.total_sold = this.roundNumber(totalSold);
    this.consumable.total_units = this.roundNumber(totalUnits);
    this.consumable.total_sales = this.roundNumber(totalSales);

    this.consumable.total_tried_ytd = this.roundNumber(totalTriedYtd);
    this.consumable.total_sold_ytd = this.roundNumber(totalSoldYtd);
    this.consumable.total_units_ytd = this.roundNumber(totalUnitsYtd);
    this.consumable.total_sales_ytd = this.roundNumber(totalSalesYtd);

    // Create display objects for YTD totals
    this.consumable.total_tried_ytd_display = {
      value: this.roundNumber(totalTriedYtd),
      fromOnlineReporting: true,
      includesCurrentWeek: true
    };

    this.consumable.total_sold_ytd_display = {
      value: this.roundNumber(totalSoldYtd),
      fromOnlineReporting: true,
      includesCurrentWeek: true
    };

    this.consumable.total_units_ytd_display = {
      value: this.roundNumber(totalUnitsYtd),
      fromOnlineReporting: true,
      includesCurrentWeek: true
    };

    this.consumable.total_sales_ytd_display = {
      value: this.roundNumber(totalSalesYtd),
      fromOnlineReporting: true,
      includesCurrentWeek: true
    };
  }

  /** Escapes a value before it is interpolated into HTML assigned to innerHTML. */
  private escapeHtml(value: any): string {
    return String(value ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /**
   * Generates tooltip content for dropped enrollment details
   * @param type The type of enrollment (pre_original, original, renewal, extension)
   * @param isYtd Whether to use year-to-date data
   * @returns Formatted HTML string for tooltip display
   */
  getDroppedEnrollmentTooltip(type: string, isYtd: boolean = false): string {
    // Get the appropriate array based on type and whether it's YTD
    const arrayName = isYtd ? `${type}_sales_dropped_ytd_ui` : `${type}_sales_dropped_ui`;
    const dropsArray = this.consumable?.[arrayName];

    LoggerService.log('Tooltip data for', arrayName, dropsArray);

    if (!dropsArray || dropsArray.length === 0) {
      return '<div style="background-color: #ffffff; padding: 15px;">No dropped enrollments to display</div>';
    }

    let tooltipContent = '<div class="tooltip-table" style="background-color: #ffffff; padding: 15px;">';
    tooltipContent += '<table style="background-color: #ffffff; width: 100%; border-collapse: collapse; margin-bottom: 0;">';
    tooltipContent += '<thead><tr>';
    tooltipContent += '<th style="background-color: #f2f2f2; padding: 8px 12px; text-align: left; font-weight: bold; border: 1px solid #ddd;">Student</th>';
    tooltipContent += '<th style="background-color: #f2f2f2; padding: 8px 12px; text-align: left; font-weight: bold; border: 1px solid #ddd;">Package</th>';
    tooltipContent += '<th style="background-color: #f2f2f2; padding: 8px 12px; text-align: left; font-weight: bold; border: 1px solid #ddd;">Date Enrolled</th>';
    tooltipContent += '<th style="background-color: #f2f2f2; padding: 8px 12px; text-align: left; font-weight: bold; border: 1px solid #ddd;">Date Dropped</th>';
    tooltipContent += '<th style="background-color: #f2f2f2; padding: 8px 12px; text-align: center; font-weight: bold; border: 1px solid #ddd;">Total</th>';
    tooltipContent += '<th style="background-color: #f2f2f2; padding: 8px 12px; text-align: center; font-weight: bold; border: 1px solid #ddd;">Used</th>';
    tooltipContent += '<th style="background-color: #f2f2f2; padding: 8px 12px; text-align: center; font-weight: bold; border: 1px solid #ddd;">Unused</th>';
    tooltipContent += '<th style="background-color: #f2f2f2; padding: 8px 12px; text-align: right; font-weight: bold; border: 1px solid #ddd;">Amount</th>';
    tooltipContent += '</tr></thead><tbody>';

    dropsArray.forEach((drop, index) => {
      const rowStyle = index % 2 === 0 ? 'background-color: #ffffff;' : 'background-color: #f9f9f9;';
      tooltipContent += `<tr style="${rowStyle}">`;
      tooltipContent += `<td style="padding: 8px 12px; border: 1px solid #ddd;">${this.escapeHtml(drop.student_name)}</td>`;
      tooltipContent += `<td style="padding: 8px 12px; border: 1px solid #ddd;">${this.escapeHtml(drop.package_name)}</td>`;
      tooltipContent += `<td style="padding: 8px 12px; border: 1px solid #ddd;">${this.formatDate(drop.date_enrolled)}</td>`;
      tooltipContent += `<td style="padding: 8px 12px; border: 1px solid #ddd;">${this.formatDate(drop.date_dropped)}</td>`;
      tooltipContent += `<td style="padding: 8px 12px; text-align: center; border: 1px solid #ddd;">${drop.lessons_total}</td>`;
      tooltipContent += `<td style="padding: 8px 12px; text-align: center; border: 1px solid #ddd;">${drop.lessons_used}</td>`;
      tooltipContent += `<td style="padding: 8px 12px; text-align: center; border: 1px solid #ddd;">${drop.lessons_unused}</td>`;
      tooltipContent += `<td style="padding: 8px 12px; text-align: right; border: 1px solid #ddd;">${this.currencyService.format(drop.amount)}</td>`;
      tooltipContent += '</tr>';
    });

    tooltipContent += '</tbody></table></div>';
    return tooltipContent;
  }

  /**
   * Format date for tooltip display
   * @param dateString Date string to format
   * @returns Formatted date string (MM/DD/YYYY)
   */
  private formatDate(dateString: string): string {
    return this.reportDateService.formatDate(dateString);
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');

    // Check if paginator exists before accessing its properties
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }

    // DO NOT call updateRouterParams here - this prevents duplicate requests
    // The routing has already been handled by pageChanged() or other methods
    LoggerService.log('setupPagination called - skipping route update to prevent duplicates');
  }

  /**
   * Super-admin only: clears the stored weekly tried/sold counters for this
   * studio on the backend, then reloads the report so the numbers recompute
   * from current data.
   */
  clearReportCache() {
    this.ShowProgressBar = true;
    this._drupalRESTService.httpPOST('/api/studio-metrics/tried-sold/clear', {})
      .subscribe({
        next: () => {
          this._snackBar.open('Report cache cleared. Recomputing from current data.', 'Dismiss', { duration: 5000 });
          this.getData(this.queryParams || []);
        },
        error: (error) => {
          this.ShowProgressBar = false;
          this.handleError(error);
        }
      });
  }

  override onPrint() {
    let content = `
      <div class="print-container">
        <h2 class="report-title">Studio Business Summary</h2>
        <p class="report-period">Week ${this.week}, ${this.year}</p>
        <p class="report-studio">${this.currentStudio}</p>
    `;

    // Get and add the header table
    const headerTable = document.querySelector('.container-fluid table.mat-table');
    if (headerTable && headerTable.parentElement?.offsetParent !== null) {
      const clonedHeader = headerTable.cloneNode(true) as HTMLElement;
      content += '<div class="header-section">' + clonedHeader.outerHTML + '</div>';
    }

    // Start the two-column grid layout
    content += '<div class="content-grid">';

    // Get left column content (first report column). The layout uses responsive
    // Bootstrap classes (col-12 col-lg-6), so match on col-lg-6, not col-6.
    const reportColumns = document.querySelectorAll('.container-fluid .row.g-3 > .col-lg-6');
    const leftColumn = reportColumns[0] || null;
    if (leftColumn) {
      content += '<div class="left-column">';

      // Get all sections in left column
      const leftSections = leftColumn.querySelectorAll('h2');
      leftSections.forEach((header: any) => {
        content += `<div class="section">`;
        content += `<h2>${header.textContent}</h2>`;

        // Get the table that follows this header
        let nextElement = header.nextElementSibling;
        while (nextElement && nextElement.tagName !== 'H2') {
          if (nextElement.tagName === 'TABLE') {
            const clonedTable = nextElement.cloneNode(true) as HTMLElement;
            // Clean up Angular artifacts
            clonedTable.querySelectorAll('[mat-sort-header], .mat-sort-header-container').forEach((el: HTMLElement) => {
              el.removeAttribute('mat-sort-header');
            });
            content += clonedTable.outerHTML;
            break;
          }
          nextElement = nextElement.nextElementSibling;
        }
        content += `</div>`;
      });

      content += '</div>'; // end left-column
    }

    // Get right column content (second report column)
    const rightColumn = reportColumns[1] || null;
    if (rightColumn && rightColumn !== leftColumn) {
      content += '<div class="right-column">';

      // Get all sections in right column
      const rightSections = rightColumn.querySelectorAll('h2');
      rightSections.forEach((header: any) => {
        content += `<div class="section">`;
        content += `<h2>${header.textContent}</h2>`;

        // Get the table that follows this header
        let nextElement = header.nextElementSibling;
        while (nextElement && nextElement.tagName !== 'H2') {
          if (nextElement.tagName === 'TABLE') {
            const clonedTable = nextElement.cloneNode(true) as HTMLElement;
            // Clean up Angular artifacts
            clonedTable.querySelectorAll('[mat-sort-header], .mat-sort-header-container').forEach((el: HTMLElement) => {
              el.removeAttribute('mat-sort-header');
            });
            content += clonedTable.outerHTML;
            break;
          }
          nextElement = nextElement.nextElementSibling;
        }
        content += `</div>`;
      });

      content += '</div>'; // end right-column
    }

    content += '</div>'; // end content-grid
    content += '</div>'; // end print-container

    const styles = `
      /* Layout and page setup */
      @media print {
        @page {
          size: landscape;
          margin: 0.4in;
        }
        body {
          zoom: 1;
          transform: scale(1);
          transform-origin: top left;
          width: 100%;
          padding: 0 !important; /* Override print service padding */
        }
      }

      .print-container {
        font-family: Arial, sans-serif;
        font-size: 11px;
      }

      /* Report header */
      .report-title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 5px;
      }

      .report-period {
        font-size: 14px;
        text-align: center;
        margin-bottom: 5px;
      }

      .report-studio {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 15px;
      }

      /* Header table section */
      .header-section {
        margin-bottom: 10px;
      }

      .header-section table {
        width: 100%;
        margin-bottom: 5px;
      }

      /* Two-column grid layout */
      .content-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
        width: 100%;
        box-sizing: border-box;
      }

      .left-column,
      .right-column {
        min-width: 0; /* Prevent overflow */
        box-sizing: border-box;
        overflow: hidden;
      }

      /* Section styling */
      .section {
        margin-bottom: 15px;
        page-break-inside: avoid;
      }

      .section h2 {
        font-size: 14px;
        font-weight: bold;
        margin: 10px 0 5px 0;
        text-transform: uppercase;
        border-bottom: 1px solid #999;
        padding-bottom: 3px;
      }

      /* Table styling */
      table {
        width: 100%;
        border-collapse: collapse;
        margin: 0;
        font-size: 9px;
      }

      th, td {
        padding: 2px 4px;
        border: 1px solid #ccc;
        text-align: left;
        font-size: 9px;
      }

      th {
        background-color: #f0f0f0;
        font-weight: bold;
        font-size: 9px;
      }

      /* Material table classes */
      .mat-header-cell {
        font-weight: bold;
        background-color: #f0f0f0;
      }

      .mat-row {
        background-color: white;
      }

      /* Number alignment */
      td:not(:first-child) {
        text-align: right;
      }

      td:first-child,
      th:first-child {
        text-align: left;
      }

      /* Hide Angular Material sorting artifacts */
      .mat-sort-header-container,
      .mat-sort-header-arrow,
      .mat-sort-header-pointer-left,
      .mat-sort-header-pointer-right,
      .mat-sort-header-pointer-middle,
      .material-icons,
      .online-reporting-icon {
        display: none !important;
      }

      /* Clean up Angular directives */
      [mat-sort-header],
      [matTooltip],
      [appHtmlTooltip] {
        cursor: default !important;
      }

      /* Nested tables */
      table table {
        width: 100%;
        margin: 0;
      }

      /* Alternate row coloring */
      tbody tr:nth-child(even) {
        background-color: #f9f9f9;
      }

      /* Page break control */
      @media print {
        .content-grid {
          page-break-inside: avoid;
        }

        .section {
          page-break-inside: avoid;
        }

        /* If content is too long, allow page break between sections */
        .left-column,
        .right-column {
          page-break-inside: auto;
        }
      }

      /* Prevent headers from repeating on each page */
      thead {
        display: table-row-group;
      }

      tr {
        page-break-inside: avoid;
      }
    `;

    this._printService.print(content, {
      title: `Studio Business Summary - Week ${this.week}, ${this.year}`,
      styles: styles,
      promptPrint: true
    });
  }
}
